import { getToday, getSubMonthsDate, getTodayPlus7, getSubDaysDate } from '../libs/date'

export const DATE_FORMAT = 'dd/MM/yyyy'
export const MIN_CODE_LENGTH_TO_SEARCH = 4
export const CODE_VALIDATION_FN = code =>
  code === '' || code.length < MIN_CODE_LENGTH_TO_SEARCH
export const MULTILINE_MAX_LENGTH = 500
export const ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50]
export const ADDRESS_LIST_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[0]
export const SHIPPINGS_TABLE_DEFAULT_PAGE = 0
export const SHIPPINGS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const INCIDENTS_TABLE_DEFAULT_PAGE = 0
export const INCIDENTS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const RETURNS_TABLE_DEFAULT_PAGE = 0
export const RETURNS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const UNSCHEDULED_PICKUP_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS.length - 1
  ]

export const START_DATE_QUARTER_DATA = getSubMonthsDate(3)
export const START_DATE_7_SUB_DATA = getSubDaysDate(6)
export const START_DATE_LAST_MONTH = getSubDaysDate(30)
export const TODAY_DATE = getToday()
export const TODAY_PLUS_7_DATE = getTodayPlus7()

export const COMPROMISED_SHIPMENTS_MAX = 5000


export const SHIPPINGS_STATIC_DEFAULT_FILTERS = {
  postalCodeSource: 'destin',
  dateFrom: START_DATE_QUARTER_DATA,
  dateTo: TODAY_DATE,
  shippingsPage: SHIPPINGS_TABLE_DEFAULT_PAGE,
  shippingsRowsPerPage: SHIPPINGS_TABLE_DEFAULT_ROWS_PER_PAGE,
  shippingsSortType: 'desc',
  shippingsSortColumn: 'shippingDate',
  incidentsPage: INCIDENTS_TABLE_DEFAULT_PAGE,
  incidentsRowsPerPage: INCIDENTS_TABLE_DEFAULT_ROWS_PER_PAGE,
  incidentsSortType: 'desc',
  incidentsSortColumn: 'shippingDate',
  returnsPage: RETURNS_TABLE_DEFAULT_PAGE,
  returnsRowsPerPage: RETURNS_TABLE_DEFAULT_ROWS_PER_PAGE,
  returnsSortType: 'desc',
  returnsSortColumn: 'shippingDate',
  unscheduledPickupSortType: 'desc',
  unscheduledPickupSortColumn: 'shippingDate',
  unscheduledPickupRowsPerPage: UNSCHEDULED_PICKUP_TABLE_DEFAULT_ROWS_PER_PAGE,
  selectedTracking: 'shipping',
}

export const SHIPPINGS_TABLE_HEADER_ORDER = [
  'shippingCode',
  'manifestDate',
  'shippingStatusCode',
  'clientCenterCode',
  'clientReference',
  'senderAddress2',
  'destinAddress2',
  'recipientName',
]

export const SHIPPINGS_TABLE_HEAD_CELLS = [
  {
    id: 'shippingCode',
    sortable: true,
    extraClass: 'big',
  },
  {
    id: 'shippingDate',
    sortable: true,
    extraClass: 'small',
  },
  {
    id: 'shippingStatusCode',
    sortable: true,
  },
  { id: 'clientCenterCode', sortable: true },
  { id: 'clientReference', sortable: true },
  { id: 'senderAddress2', sortable: true },
  { id: 'destinAddress2', sortable: true },
  { id: 'recipientName', sortable: true },
]

export const SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'shippingCode', extraClass: 'big' },
  { id: 'shippingDate', extraClass: 'small' },
  { id: 'shippingStatusCode' },
  { id: 'clientCenterCode' },
  { id: 'clientReference' },
  { id: 'senderAddress2' },
  { id: 'destinAddress2' },
  { id: 'recipientName' },
]

export const SHIPPINGS_RECORDING_TABLE_HEAD_CELLS = [
  { id: 'status' },
  { id: 'file_name', extraClass: 'big', sortable: true },
  { id: 'upload_datetime', extraClass: 'small', sortable: true },
  { id: 'success_lines', extraClass: 'small', sortable: false },
  { id: 'error_lines', extraClass: 'small', sortable: false },
  { id: 'actionButtons' },
]

export const SHIPPINGS_RECORDING_TABLE_HEADER_ORDER = [
  'status',
  'file_name',
  'upload_date',
  'success_lines',
  'error_lines',
  'actionButtons',
]

export const IMPORTED_CONTACTS_TABLE_HEAD_CELLS = [
  { id: 'status' },
  { id: 'file_name', extraClass: 'big' },
  { id: 'upload_datetime', extraClass: 'small', sortable: false },
  { id: 'upload_hour', extraClass: 'small', sortable: false },
  { id: 'success_lines_agenda', extraClass: 'small', sortable: false },
  { id: 'error_lines_agenda', extraClass: 'small', sortable: false },
  //{ id: 'actionButtons' },
]

export const IMPORTED_CONTACTS_TABLE_HEADER_ORDER = [
  'status',
  'file_name',
  'upload_datetime',
  'upload_hour',
  'success_lines_agenda',
  'error_lines_agenda',
  //'actionButtons',
]

export const AGENDA_TABLE_HEADER_ORDER = [
  'contact-client-code',
  'name-company',
  'phone',
  'email',
  'address',
]

export const AGENDA_TABLE_HEAD_CELLS = [
  { id: 'contact-client-code', extraClass: 'medium', sortable: true },
  { id: 'name-company', extraClass: 'medium', sortable: true },
  { id: 'phone', extraClass: 'small', sortable: true },
  { id: 'email', extraClass: 'small', sortable: true },
  { id: 'address', extraClass: 'small', sortable: true },
]

export const REPORTS_CONFIG_TABLE_HEADER_ORDER = [
  'name',
  'description',
  'subscription',
  //'type',
  //'settings',
]

export const REPORTS_CONFIG_TABLE_HEAD_CELLS = [
  {
    id: 'name',
    sortable: true,
    extraClass: 'small',
  },
  {
    id: 'description',
    sortable: true,
    extraClass: 'big',
  },
  {
    id: 'subscription',
    sortable: false,
  },
  // {
  //   id: 'type',
  //   sortable: false,
  // },
  // {
  //   id: 'settings',
  //   sortable: false,
  // },
]

export const REPORTS_CONFIG_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'name', extraClass: 'big' },
  { id: 'description', extraClass: 'small' },
  { id: 'subscription' },
  //{ id: 'type' },
  //{ id: 'settings' },
]

export const REPORTS_TABLE_HEADER_ORDER = ['name', 'date', 'download']

export const REPORTS_TABLE_HEAD_CELLS = [
  {
    id: 'name',
    sortable: false,
    extraClass: 'big',
  },
  {
    id: 'date',
    sortable: false,
    extraClass: 'small',
  },
  {
    id: 'download',
    sortable: false,
  },
]

export const REPORTS_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'name', extraClass: 'big' },
  { id: 'date', extraClass: 'small' },
  { id: 'download' },
]

export const REPORT_TYPES = [
  { id: 'WEB', text: 'Web' },
  {
    id: 'FTP',
    text: 'FTP',
  },
  { id: 'Email', text: 'Email' },
]

//business-constants

// TODO: change names for NEW, DEFAULT, AGENDA
export const ADDRESS_STATES = {
  NEW: 'NEW',
  EXISTING: 'EXISTING',
  AT_PICKUP_POINT: 'AT_PICKUP_POINT',
}

export const ADDRESS_SOURCES = {
  clientCentersList: 'clientCentersList',
  newAddress: 'newAddress',
  pickUpPoint: 'pickUpPoint',
}

export const ADDRESS_TYPE_CODE = {
  ORIGIN: 'ORIGIN',
  DESTIN: 'DESTIN',
}

export const STEPS = {
  FROM: 'from',
  TO: 'to',
  SHIPMENT: 'shipment',
  CUSTOMS: 'customs',
  SERVICES: 'services',
  SUMMARY: 'summary',
}

export const OLD_SHIPPING_STATUS_CODES = {
  manifested: '0000',
  incident: '1600',
  inTransit: '0900',
  delivered: '2100',
}

export const SHIPPING_STATUS_CODES = {
  manifested: 'WEB0000', //Grabado
  collected: 'WEB0500', //Recogido
  failedCollected: 'WEB0600', //Recogido
  inTransit: 'WEB1000', //En tránsito
  delivering: 'WEB1500', //En reparto
  deliveringFilter: 'WEB1500,WEB2300', //En reparto
  storedIncident: 'WEB1700,WEB1800',
  stored: 'WEB1700,WEB1800,WEB1900',
  incidentDelivering: 'WEB1600', //En reparto con incidencia
  delivered: 'WEB2100', //Entregado
  pudo: 'WEB2310', //Entregado en Punto CTT
  returned: 'WEB2500', //Devuelto
  cancelled: '3000', // Anulado
  nulled: 'WEB3000', // Anulado
  onHold: 'WEB...', //En pudo - Todavía sin el código definitivo
  //TODO: REVISAR NOMENCLATURA Y ELIMINAR ESTOS 2 REL. INCIDENCIAS
  //eliminar esta constante y que se obtenga de resp API
  failedDelivery: 'WEB1600',
  incidents: 'incidents',
  depositPending: 'WEB0020',
  deposited: 'WEB0030',
  provisionalBox: 'WEB0010',
}

// El endpoint unificado (POST .../item-history-api/private/v2/rpc-shippings)
// informa `shipping_status_code`/`current_status_code` SIN el prefijo 'WEB'
// (confirmado contra payload real: '0000' en vez de 'WEB0000'), a diferencia
// de `events[].code` y del catálogo de estados del usuario (statusList), que
// sí lo llevan. Mismas claves que SHIPPING_STATUS_CODES, sin el prefijo.
export const SHIPPING_STATUS_CODES_NO_WEB = {
  manifested: '0000',
  collected: '0500',
  failedCollected: '0600',
  inTransit: '1000',
  delivering: '1500',
  deliveringFilter: '1500,2300',
  storedIncident: '1700,1800',
  stored: '1700,1800,1900',
  incidentDelivering: '1600',
  delivered: '2100',
  pudo: '2310',
  returned: '2500',
  cancelled: '3000',
  nulled: '3000',
  onHold: '...',
  failedDelivery: '1600',
  incidents: 'incidents',
  depositPending: '0020',
  deposited: '0030',
  provisionalBox: '0010',
}

export const RESOLVED_STATUS_CODES = ['71_INAT', '75_INAT', '79_INAT']

export const MOBILE_HOME_TABS = {
  SHIPMENTS: 'shipments',
  INCIDENTS: SHIPPING_STATUS_CODES.incidents,
  UNSCHEDULED: 'unscheduled',
}

export const SHIPPING_WITH_REFUND_CODE = 'REE'
export const SHIPPING_WITH_INSURANCE_MERCHAND_CODE = 'VDE'
export const SHIPPING_WITH_SLIP_SCAN = 'EAC'
export const SHIPPING_WITH_RETURN = 'RET'
export const SHIPPING_WITH_PUDO = 'PER'
export const SHIPPING_WITH_ORIGIN_PUDO = 'RDP'
export const SHIPPING_WITH_ERE = 'ERE'

export const IS_RESOLVING_INCIDENTS_ALLOWED = true
export const INCIDENT_CODE_INCORRECT_ADDRESS = '1_INCT'
export const INCIDENT_CODE_NO_ANSWER_RE = `2_INCT&${SHIPPING_STATUS_CODES.delivering}`
export const INCIDENT_CODE_NO_ANSWER = '2_INCT'
export const INCIDENT_CODE_NO_ANSWER_R = `2_INCT&${SHIPPING_STATUS_CODES.collected}`
export const INCIDENT_CODE_REFUSED = '4_INCT'
export const INCIDENT_CODE_NO_EFFECTIVE = '1005_INCT'
export const INCIDENT_CODE_RESOLVED = '50_INCT'

export const INCIDENT_CODE_MISSING_DOCUMENTATION = '21_INCT';
export const INCIDENT_CODE_CLIENT_NO_MERCHANDISE = '25_INCT';
export const INCIDENT_CODE_INVALID_DNI_PIN = '27_INCT';
export const INCIDENT_CODE_SPECIAL_HANDLING_REQUEST = '30_INCT';
export const INCIDENT_CODE_LOCAL_HOLIDAY = '31_INCT';
export const INCIDENT_CODE_FORCE_MAJEURE_INACCESSIBLE_AREA = '37_INCT';
export const INCIDENT_CODE_NOT_ADMITTED_SYSTEM_ERROR = '42_INCT';
export const INCIDENT_CODE_NOT_ADMITTED_REFUSES_CTT = '43_INCT';
export const INCIDENT_CODE_RECIPIENT_REFUSES_PAYMENT = 'P9_INCT';
export const INCIDENT_CODE_LOCKER_NOT_OPERATIONAL = '41_INCT';
export const INCIDENT_CODE_POINT_CTT_CLOSED_VACATION = '40_INCT';
export const INCIDENT_CODE_POINT_CTT_CLOSED_PERMANENTLY = '49_INCT';
export const INCIDENT_CODE_LOCKER_FULL = '54_INCT';
export const INCIDENT_CODE_LOCKER_TOO_SMALL = '56_INCT';
export const INCIDENT_CODE_LOCKER_NO_SUITABLE_SPACE = '57_INCT';
export const INCIDENT_CODE_NO_TIME_FOR_SERVICE = '101_INCT';
export const INCIDENT_CODE_INCOMPLETE_SHIPMENT = '1020_INCT';
export const INCIDENT_CODE_FORCE_MAJEURE_WEATHER = '1034_INCT';

export const INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION = [
  INCIDENT_CODE_INCORRECT_ADDRESS,
  INCIDENT_CODE_NO_ANSWER,
  INCIDENT_CODE_REFUSED,
  INCIDENT_CODE_NO_EFFECTIVE,
  INCIDENT_CODE_RESOLVED,
  INCIDENT_CODE_MISSING_DOCUMENTATION,
  INCIDENT_CODE_CLIENT_NO_MERCHANDISE,
  INCIDENT_CODE_INVALID_DNI_PIN,
  INCIDENT_CODE_SPECIAL_HANDLING_REQUEST,
  INCIDENT_CODE_LOCAL_HOLIDAY,
  INCIDENT_CODE_FORCE_MAJEURE_INACCESSIBLE_AREA,
  INCIDENT_CODE_NOT_ADMITTED_SYSTEM_ERROR,
  INCIDENT_CODE_NOT_ADMITTED_REFUSES_CTT,
  INCIDENT_CODE_RECIPIENT_REFUSES_PAYMENT,
  INCIDENT_CODE_LOCKER_NOT_OPERATIONAL,
  INCIDENT_CODE_POINT_CTT_CLOSED_VACATION,
  INCIDENT_CODE_POINT_CTT_CLOSED_PERMANENTLY,
  INCIDENT_CODE_LOCKER_FULL,
  INCIDENT_CODE_LOCKER_TOO_SMALL,
  INCIDENT_CODE_LOCKER_NO_SUITABLE_SPACE,
  INCIDENT_CODE_NO_TIME_FOR_SERVICE,
  INCIDENT_CODE_INCOMPLETE_SHIPMENT,
  INCIDENT_CODE_FORCE_MAJEURE_WEATHER,
];

export const SERVICES_NAMES = {
  C24: 'CTT e24h',
  C48: 'CTT e48h',
  C14: 'CTT 14h',
  C10: 'CTT 10h',
  C14E: 'CTT Premium Empresas 14h',
  CCA24: 'CTT Canarias Aéreo 24h',
  CCA48: 'CTT Canarias Aéreo 48h',
  CCAE: 'CTT Canarias Documentación',
  CCAM: 'CTT Canarias Marítimo',
  CBA24: 'CTT Baleares Express',
  CBA48: 'CTT Baleares Economy',
  CIEX: 'CTT Internacional Express',
  CIES: 'CTT Internacional Economy',
  CIEL: 'CTT Internacional Europa Light',
}

export const CUSTOMS = {
  manifested: 'WEB0000',
  collected: 'WEB0500',
}

export const CUSTOM_SELECT_TYPE = [
  {
    id: 'PERSONAL_NATIONAL',
    text: 'shipping-send-form:customs:form:individual',
  },
  { id: 'BUSINESS_UNION', text: 'shipping-send-form:customs:form:company' },
]

export const AGENDA_CUSTOMS_TYPE = [
  { id: 'COMPANY', text: 'shipping-send-form:customs:form:company' },
  { id: 'INDIVIDUAL', text: 'shipping-send-form:customs:form:individual' },
]

export const CUSTOM_SELECT_REASON = [
  { id: 'SOLD', text: 'shipping-send-form:customs:form:select:sold' },
  {
    id: 'REPAIR_AND_RETURN',
    text: 'shipping-send-form:customs:form:select:repair_and_return',
  },
  { id: 'SAMPLE', text: 'shipping-send-form:customs:form:select:sample' },
  {
    id: 'PERSONAL_EFFECTS',
    text: 'shipping-send-form:customs:form:select:personal_effects',
  },
]

export const CUSTOM_FILE_TYPE = [
  {
    id: 'CERTIFICATE_OF_ORIGIN',
    text: 'shipping-send-form:customs:form:select:certificate_of_origin',
  },
  { id: 'OTHER', text: 'shipping-send-form:customs:form:select:other' },
]

export const WEB_VIDEOS = [
  {
    name: 'Píldora menú principal',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/Pildora%20men%C3%BA%20Principal.mp4',
  },
  {
    name: 'Píldora solicitar envío',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20solicitar%20env%C3%ADo.mp4',
  },
  {
    name: 'Píldora seguimiento',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20seguimiento.mp4',
  },
  {
    name: 'Píldora facturación',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20facturaci%C3%B3n.mp4',
  },
  {
    name: 'Píldora ajustes de impresión',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20ajustes%20de%20impresi%C3%B3n.mp4',
  },
  {
    name: 'Píldora ayuda y soporte',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20ayuda%20y%20soporte.mp4',
  },
  {
    name: 'Píldora zona usuario',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20zona%20usuario.mp4',
  },
]

export const SHIPPINGS_RECORDING_USERS = [
  "45135", "40574", "40193", "90132", "00002", "42575", "46834", "46952", "46648", "40878", '47227', "44213", "40966", "47216", "47222", "47418", "47263", "47597", "45848", "47290", "47647", "30168", "40134", "47862", "47686", "47454", "47911", "47903", "47993", "43630", "47703"
];

export const PORTUGAL_USERS = [
  "4671400001", // CARGOPRIME
  "4671400002", // Aulam
  "4671400003", // Cribigar SL
  "4671400004", // E-Pro Quality
  "4671400005", // Electrorime / EveryKip
  "4671400006", // Emir Bey
  "4671400007", // Halveria
  "4671400008", // Nyxia
  "4671400009", // Sweet Problems Solutions Products
  "4671400010", // Thingssol
  "4671400011", // Titan Treasure
  "4671400012", // Wednesday SHOP WS
  "4671400013", // Willow
  "4671400014", // AFPRO
  "4671400015", // Gygaflex
  "4671400016", // PAMH
  "4671400017", // NICEOWL, SL
  "4671400018", // HORIZON ECOMMERCE
  "4671400019", // 3JGelements
  "4671400020", // PROTINO SHOPPIFY
  "4671400021", // FREE EUPHORIA
  "4671400022", // PADLUX
  "4671400023", // VIANITY
  "4671400024", // ALMAFINE
  "4671400025", // MINDCO
  "4671400026", // PYN SPOT
  "4671400027", // YANUM
  "4671400028", // DAIMON
  "4671400029", // SWEETSOLUTION
  "4640300011",
  "4513500001",
  "4671400002",
  "4671400014",
  "4671400018",
  "4671400029",
  "4671400024",
  "4671400026",
  "4671400011",
  "4671400003",
  "4671400016",
  "4671400022",
  "4671400025",
  "4671400006",
  "4671400023",
  "4671400027",
  "4671400019",
  "4671400020",
  "4671400001",
  "4671400013",
  "4671400004",
  "4671400005",
  "4671400021",
  "4671400017",
  "4671400007",
  "4671400015",
  "4671400028",
  "4671400008",
  "4671400012",
  "4671400009",
  "4671400010"
];


export const LABELS_PICK_UP_POINT = {
  PUNTO_COLLECT_EXPRESS: 'PUNTO PICK&DROP',
  TAQUILLA_LOCKY: 'LOCKY PICK&DROP '
}